import { useGetContentHeroBannerQuery } from 'domains/merchandising/api'

interface HeroBannerArgs {
  id: string
  retailerId: string
}

export const useGetQueryHeroBanner = ({ id, retailerId }: HeroBannerArgs) => {
  const { data, error, loading } = useGetContentHeroBannerQuery({
    fetchPolicy: 'cache-and-network',
    variables: {
      id,
      retailerId,
    },
  })

  return {
    apiResult: data?.storefrontPlacement,
    apiSuccess: Boolean(data),
    apiLoading: loading,
    apiError: error,
  }
}
